import { FC } from "react";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import {
  setConfirmationByMessageModal,
  setErrorMessageByVoteModal,
  setSuccessMessageByVoteModal,
} from "../../../../store/slices/main";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import { TCodeForm } from "../../../../types/vote";
import {
  selectContestsState,
  setConfirmationByMessage,
} from "../../../../store/slices/contests";
import confirmationByMessage from "../../../../api/asyncThuncks/confirmationByMessage";

const ConfirmationByMessageModal: FC = () => {
  const dispatch = useAppDispatch();
  const { сonfirmationByMessage } = useAppSelector(selectContestsState);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<TCodeForm>({
    defaultValues: {
      code: undefined,
    },
    mode: "onSubmit",
  });

  const onSubmit: SubmitHandler<TCodeForm> = async (data) => {
    dispatch(
      setConfirmationByMessage({
        phone: сonfirmationByMessage.phone,
        contestId: сonfirmationByMessage.contestId ?? "",
        audioTrackId: сonfirmationByMessage.audioTrackId,
      })
    );
    const result = await dispatch(
      confirmationByMessage({
        phone: сonfirmationByMessage.phone,
        code: data.code,
        contestId: сonfirmationByMessage.contestId ?? "",
        audioTrackId: сonfirmationByMessage.audioTrackId,
      })
    );
    dispatch(setConfirmationByMessageModal(false));
    if (confirmationByMessage.fulfilled.match(result)) {
      dispatch(setSuccessMessageByVoteModal(true));
    } else {
      dispatch(setErrorMessageByVoteModal(true));
    }
  };

  return (
    <div className="w-full px-8">
      <div className="w-full max-w-[30rem] h-[18rem] text-center">
        <h2 className="text-xl font-bold" id="modal-title">
          Введіть код з SMS
        </h2>
        <h5 className="text-sm leading-6 pt-3">
          Код відправлено на номер
          <br />
          {сonfirmationByMessage.phone}
        </h5>

        <form onSubmit={handleSubmit(onSubmit)} className="pt-5">
          <div
            className="w-full sm:min-w-[27rem] flex-col"
            style={{ fontStretch: "ultra-expanded" }}
          >
            <div className="pt-1.5">
              <Controller
                name="code"
                control={control}
                rules={{
                  required: "От халепа! Це поле обовʼязкове",
                  pattern: {
                    value: /^[0-9]{4}$/,
                    message: "Код повинен містити 4 цифри",
                  },
                }}
                render={({ field }) => (
                  <>
                    <input
                      placeholder="••••"
                      type="text"
                      maxLength={4}
                      {...field}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        field.onChange(value);
                      }}
                      style={{
                        letterSpacing: "1.2em",
                      }}
                      className={`text-center  font-stretch- box-border w-full px-1.5 py-3 mb-7 text-sm font-normal border-[1.5px] rounded-md outline-none ${
                        errors.code
                          ? "border-[#EC221F] focus:border-[#EC221F]"
                          : "border-light_gray focus:border-orange focus:border-2"
                      }`}
                    />
                  </>
                )}
              />
            </div>
          </div>
          <div className="w-full flex justify-center">
            <button
              type="submit"
              className="w-full mt-1 px-3 py-3 bg-orange text-sm text-white rounded-md hover:bg-orange-dark transition"
            >
              Продовжити
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConfirmationByMessageModal;
